<template>
  <div class="finish">
    {{ message }}
  </div>
</template>

<script>
import Axios from 'axios';

export default {
  data() {
    return {
      loading: false,
      message: ''
    }
  },

  props: {
    token: {
      type: [String, Number],
      default: ''
    }
  },

  created() {
    this.toNewStatus();
  },

  methods: {
    async toNewStatus() {
      this.loading = true;

      await Axios.put(`/1.0/spec-public/sportmaster/interview/${this.token}/finish`)
        .then(response => {
          if (response.data.message === 'success') {
            this.message = 'Спасибо! Мы получили ваш ответ, и скоро с вами свяжемся!';
          } else if (response.data.message === 'duplicate') {
            this.message = 'Спасибо, мы уже получили ваш ответ. Свяжемся с вами совсем скоро!';
          } else {
            this.message = 'Переход в следующий статус не осуществлен. Свяжитесь, пожалуйста, со службой поддержки.'
          }
        })
        .finally(() => {
          this.loading = false;
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.finish {
  margin: 50px auto;
  max-width: 500px;
  background: #fff;
  box-shadow: 0px 1px 40px rgba(28,50,75,0.05);
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 40px;
  text-align: center;
  color: #333;
  font-size: 18px;
  line-height: 1.8;
}
</style>
